import {
  DutyTaxPaymentTermsEnum,
  ExportPaymentTermsEnum,
  ImportPaymentTermsEnum
} from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';
import i18n from '@/plugins/i18n';

export function dutyTaxPaymentTermsOptions(): SelectOption<string>[] {
  return [
    DutyTaxPaymentTermsEnum.within_next_3_wdays_ata,
    DutyTaxPaymentTermsEnum.within_next_5_wdays_ata,
    DutyTaxPaymentTermsEnum.within_next_10_wdays_ata,
    DutyTaxPaymentTermsEnum.within_next_20_wdays_ata,
    DutyTaxPaymentTermsEnum.within_5_wdays_next_month_ata,
    DutyTaxPaymentTermsEnum.end_next_month_ata
  ].map((val: DutyTaxPaymentTermsEnum) => {
    return { value: val, label: i18n.t(`company.payment-terms.duty-tax.${val}`).toString() };
  });
}

export function exportPaymentTermsOptions(): SelectOption<string>[] {
  return [
    ExportPaymentTermsEnum.prepaid,
    ExportPaymentTermsEnum.within_next_3_wdays_atd,
    ExportPaymentTermsEnum.within_next_5_wdays_atd,
    ExportPaymentTermsEnum.within_next_10_wdays_atd,
    ExportPaymentTermsEnum.within_next_20_wdays_atd,
    ExportPaymentTermsEnum.within_5_wdays_next_month_atd,
    ExportPaymentTermsEnum.end_next_month_atd
  ].map((val: ExportPaymentTermsEnum) => {
    return { value: val, label: i18n.t(`company.payment-terms.export.${val}`).toString() };
  });
}

export function importPaymentTermsOptions(): SelectOption<string>[] {
  return [
    ImportPaymentTermsEnum.prepaid,
    ImportPaymentTermsEnum.within_next_3_wdays_ata,
    ImportPaymentTermsEnum.within_next_5_wdays_ata,
    ImportPaymentTermsEnum.within_next_10_wdays_ata,
    ImportPaymentTermsEnum.within_next_20_wdays_ata,
    ImportPaymentTermsEnum.within_5_wdays_next_month_ata,
    ImportPaymentTermsEnum.end_next_month_ata
  ].map((val: ImportPaymentTermsEnum) => {
    return { value: val, label: i18n.t(`company.payment-terms.import.${val}`).toString() };
  });
}
